// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1oi49","requiredAsterisk":"Info_requiredAsterisk__3zBr2"};